import React from 'react';
export function CoastalManagement() {
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-20">
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-21">
        <div data-id="element-22">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-23">
            Ordenamento da Orla Costeira
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-24">
            Gestão integrada das zonas costeiras, proteção ambiental e
            desenvolvimento sustentável
          </p>
          <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-25">
            Ver mais
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-26">
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-27">
            <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600" alt="Proteção Costeira" className="w-full h-full object-cover" data-id="element-28" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-4 text-white" data-id="element-29">
              <h3 className="font-bold mb-2" data-id="element-30">Proteção e Gestão</h3>
              <button className="bg-white text-blue-900 px-3 py-1 rounded text-sm font-semibold w-fit" data-id="element-31">
                Explorar
              </button>
            </div>
          </div>
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-32">
            <img src="https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=600" alt="Desenvolvimento Sustentável" className="w-full h-full object-cover" data-id="element-33" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-4 text-white" data-id="element-34">
              <h3 className="font-bold mb-2" data-id="element-35">Planeamento</h3>
              <button className="bg-white text-blue-900 px-3 py-1 rounded text-sm font-semibold w-fit" data-id="element-36">
                Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}